/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import {connect} from "react-redux";
import {BootstrapVariation} from "../../../data/bootstrap/bootstrap.variation";
import {ALERTS} from "../../../data/alertId";
import {removeAlertMessage} from "../../../actions/alerts";
import {compose} from "redux";
import {withI18N} from "../../hoc/withI18N";
import Alert from "../../atoms/bootstrap/Alert";


const handleOnClose = (e, key, props) => {
    if (e) {
        e.preventDefault();
    }
    props.removeAlertMessage(key);
};

const alert = (key, type, props, message, fallback, marginTop, marginBottom, autoClose = false) => (
    <Alert type={type} key={key} onClose={(e) => handleOnClose(e, key, props)} autoClose={autoClose}
           marginTop={props.marginTop} marginBottom={props.marginBottom}>
        <div dangerouslySetInnerHTML={{__html: (message || props.translate(fallback))}}></div>
    </Alert>);


const Alerts = (props) => {

    const alerts = props.alerts.map((key) => {
        const k = typeof key === 'string' ? key : (key && key.type === 'string' ? key.type : "");

        switch (k) {
            case ALERTS.addToCartProductError:
                return alert(k, BootstrapVariation.danger, props,
                    key.message || null,
                    "Error when adding product to cart");
            case ALERTS.addToCartBundleError:
                return alert(k, BootstrapVariation.danger, props,
                    key.message || null,
                    "Error when adding bundle to cart");
            default:
                return alert(k, BootstrapVariation.danger, props,
                    null,
                    "General error");
        }
    });

    return (
        <React.Fragment>
            {alerts.map((alert) => alert)}
        </React.Fragment>
    );
};

Alerts.propTypes = {
};

Alerts.defaultProps = {
    alerts: []
};

const mapStateToProps = (state) => ({
    alerts: state.alerts.alerts,
});

export default compose(connect(mapStateToProps, {removeAlertMessage}), withI18N)(Alerts);
